<template>
	<v-container id="starter-import-view" fluid tag="section">
		<material-card icon="mdi-upload" icon-small title="دریافت فایل اکسل باقیمانده اقساط" color="accent">
			<v-card-text>
				<v-row>
					<v-col cols="12">
						<div class="text-h5">
							لطفا فایل اکسل مورد نظر خود را با رعایت ترتیب ستون های زیر، انتخاب کنید.
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="text-center">
						<span v-for="(col, index) in columns" :key="col" class="info--text px-2" :class="{'border-left':index < columns.length - 1}">
							{{ col }}
						</span>
					</v-col>
				</v-row>
				<v-form ref="form" lazy-validation>
					<v-row align="center" justify="center">
						<v-col cols="12" sm="5">
							<v-file-input ref="file" v-model="file" :rules="[value => !!value || 'ابتدا فایل را انتخاب کنید.']" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" placeholder="" prepend-icon="mdi-file-excel-outline" label="جهت انتخاب فایل اینجا را کلیک کنید" />
						</v-col>
						<v-col cols="12" sm="2">
							<v-btn color="info" dark :loading="previewLoading" @click="preview">
								<v-icon dark>
									mdi-upload
								</v-icon>
								بارگذاری و پیش نمایش
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
				<v-row v-if="localData.importPreviewModels.length > 0" class="mt-3">
					<v-col cols="12" style="max-height:350px; overflow-y:auto">
						<div class="text-h5 primary--text text-center mt-3 mb-3">
							در جدول زیر می توانید مبالغ باقیمانده سایت و فایل را مقایسه و بررسی کنید.
						</div>
						<v-data-table :headers="headers" :items="localData.importPreviewModels" :items-per-page="500" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td class="primary--text">
										{{ row.item.systemMsg }}
									</td>
									<td class="text-center">
										{{ row.item.nationalCode }}
									</td>
									<td class="text-center">
										{{ row.item.loanCode }}
									</td>
									<td class="text-center">
										{{ row.item.remain.toString().toPriceFormat() }}
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'RemainComparerImportView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				columns: ['کد ملی', 'کد وام', 'مبلغ باقیمانده'],
				file: null,
				errorMessages: '',
				previewLoading: false,
				submitLoading: false,
				localData: {
					importPreviewModels: [],
				},
				headers: [
					{
						text: 'پیام سیستم',
						align: 'right',
						sortable: true,
						value: 'systemMsg',
						width: 200,
					}, {
						text: 'کد ملی',
						align: 'center',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'کد وام',
						align: 'center',
						sortable: true,
						value: 'loanCode',
					}, {
						text: 'مبلغ باقیمانده',
						align: 'center',
						sortable: true,
						value: 'remain',
					},
				],
				loans: [],
				summery: null,
			}
		},
		mounted() {
		},
		methods: {
			preview() {
				if (!this.$refs.form.validate()) { return }
				this.summery = null
				const formData = new FormData()
				formData.append('file', this.file)
				this.previewLoading = true
				api.post('admin/import/CompareRemainingImportPreview', formData, { contentType: 'multipart/form-data' })
					.then(
						response => {
							this.localData.importPreviewModels = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.previewLoading = false })
			},
		},
	}
</script>
<style>
</style>
